/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementConfigurationMappingBase {
    getFixupPrototypeFunction() { return JiraServiceManagementConfigurationMappingBase.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementConfigurationMappingBase>): JiraServiceManagementConfigurationMappingBase {
        let obj = Object.assign(new JiraServiceManagementConfigurationMappingBase(), model);
        JiraServiceManagementConfigurationMappingBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementConfigurationMappingBase>): JiraServiceManagementConfigurationMappingBase {
        if (!model) return null;
        return JiraServiceManagementConfigurationMappingBase.newInstance(<JiraServiceManagementConfigurationMappingBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementConfigurationMappingBase) {
        if (!obj) return;

        models.JiraServiceManagementConfigurationMappingBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementConfigurationMappingBase): boolean {
        Object.setPrototypeOf(obj, JiraServiceManagementConfigurationMappingBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the attribute
     */
    name: string;

}
